import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MODULES } from '../POS/ModuleTiles';

export default function ModuleShell({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="module-subnav">
        <NavLink to="/pos" className="module-subnav__back">
          <i className="fa fa-arrow-left" /> {t('POS', 'POS')}
        </NavLink>
        <div className="module-subnav__tiles">
          {MODULES.map((mod) => (
            <NavLink
              key={mod.to}
              to={mod.to}
              className={({ isActive }) =>
                `module-subnav__link${isActive ? ' module-subnav__link--active' : ''}`
              }
              style={{ '--tile-color': mod.color } as React.CSSProperties}
            >
              <i className={`fa ${mod.icon}`} />
              <span>{t(mod.label, mod.label)}</span>
            </NavLink>
          ))}
        </div>
      </div>
      {children}
    </div>
  );
}
